import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OccupationalDoctorService } from '@/infra/services/occupational-doctor';
import { QUERY_KEYS } from '@/utils/query-keys';

interface CreateOccupationalDoctorParams {
	name: string;
	company_id: string;
	organization_id: string;
}

const Service = OccupationalDoctorService.getInstance();

export const useCreateOccupationalDoctor = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: CreateOccupationalDoctorParams) => Service.create(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_LIST_OCCUPATIONAL_DOCTOR]);
			message.success(I18n.get('Occupational doctor created successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error on create occupational doctor'));
		}
	});
};
